module.exports = __webpack_public_path__ + "img/header-bg.463486f8.png";